import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "title", "children", "headerProps", "contentProps", "formLoop", "elements"];
import { Card, CardHeader, Grid } from '@mui/material';
export default function FormCard(props) {
    var label = props.label, _a = props.title, title = _a === void 0 ? label : _a, children = props.children, headerProps = props.headerProps, contentProps = props.contentProps, formLoop = props.formLoop, elements = props.elements, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Card, _extends({
        variant: "outlined"
    }, others), /*#__PURE__*/ React.createElement(Grid, _extends({
        container: true,
        spacing: {
            xs: 2,
            sm: 2.5
        }
    }, contentProps), title && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(CardHeader, _extends({
        title: title
    }, headerProps))), elements !== null && elements !== void 0 && elements.length ? formLoop && (elements === null || elements === void 0 ? void 0 : elements.map(formLoop)) : null));
}
